<template>
  <div class="contact-form">
    <h3 class="footer__title text--center-xs">Írj nekünk</h3>

    <div v-if="isSuccess" class="alert alert--success">
      Köszönjük, az üzenet sikeresen elküldve!<br>
      <p>
        <button
          type="button"
          class="btn btn--default btn--small"
          @click="resetForm"
        >
          Új üzenet küldése
        </button>
      </p>
    </div>

    <form v-else @submit.prevent="submit()" novalidate>
      <error-notice :messages="messages"></error-notice>

      <div class="form-group form-group--small" :class="{'has-error': errors.has('name')}">
        <input
          type="text"
          id="name"
          name="name"
          class="input input--inverse"
          placeholder="* Név"
          autocomplete="nope"
          v-model="name"
          v-validate="'required'"
          data-vv-validate-on="''"
        >
      </div>

      <div class="form-group form-group--small" :class="{'has-error': errors.has('email')}">
        <input
          type="email"
          name="email"
          class="input input--inverse"
          placeholder="* E-mail cím"
          autocomplete="nope"
          v-model="email"
          v-validate="'required|email'"
          data-vv-validate-on="''"
        >
      </div>

      <div class="form-group form-group--small" :class="{'has-error': errors.has('phone')}">
        <div class="input-group input-group--inverse">
          <span class="input-group__addon">+36</span>
          <input
            type="text"
            id="phone"
            name="phone"
            class="input input--inverse"
            placeholder="* Telefonszám"
            autocomplete="nope"
            v-model="phone"
            v-validate="'required|numeric|min:8|max:9'"
            data-vv-validate-on="''"
            maxlength="9"
          >
        </div>
      </div>

      <div class="form-group form-group--small" :class="{'has-error': errors.has('message')}">
          <textarea
            name="message"
            id="message"
            class="text text--compact text--inverse"
            cols="30"
            placeholder="* Üzenet"
            v-model="message"
            v-validate="'required'"
            data-vv-validate-on="''"
          ></textarea>
      </div>

      <div class="form-group form-group--small text--right text--center-xs">
        <button type="submit" class="btn btn--default btn--small full-width-xs">Küldés</button>
      </div>
    </form>
  </div>
</template>

<script>
  import ErrorHandler from '../mixins/error-handler'
  import { contact } from '../services/contact'
  import { formatPhone } from '../utils/user'
  import { trackEvent } from '../utils/analytics'

  export default {
    mixins: [ErrorHandler],

    data: () => ({
      name: '',
      email: '',
      phone: '',
      message: '',
      isSuccess: false
    }),

    methods: {
      resetForm () {
        this.isSuccess = false
      },

      submitForm (isValid) {
        if (!isValid) {
          return
        }

        this.preSubmit()

        contact({
          name: this.name,
          email: this.email,
          phone: formatPhone(this.phone),
          message: this.message
        })
          .then(() => {
            this.name = ''
            this.email = ''
            this.phone = ''
            this.message = ''

            this.isSuccess = true
            this.postSubmit()

            trackEvent({ event: 'contactFormSubmit' })
          })
          .catch(this.onError)
      },

      submit () {
        this.$validator.validateAll().then(this.submitForm)
      }
    }
  }
</script>

<style scoped>
.contact-form {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// ContactForm.vue?58876a67